<template>
    <svg :width="width" :height="height">
        <!-- XY-axis line -->
        <path :d="AxesData" fill="none" stroke="black" stroke-width="2" />

        <!-- Y-axis labels -->
        <text x="0" :y="getPivotTop-3" :font-size="textFontSize" text-anchor="start" fill="#666">FirstTerm</text>
        <text
                v-for="item in AxesYUnit"
                :key="item.key"
                :x="getPivotLeft-5"
                :y="item.pointY+getTextCenterPivot"
                :font-size="textFontSize"
                text-anchor="end"
                fill="#666"
        >
            {{ item.unit }}
        </text>

        <!-- X-axis labels -->
        <text
                v-for="item in AxesXUnit"
                :key="item.key"
                :x="item.pointX"
                :y="getPivotBottom+20"
                :font-size="textFontSize"
                text-anchor="middle"
                fill="#666"
        >
            {{ item.unit }}
        </text>

        <!-- Key and Color Header -->
        <path d="M 120,10 L 140,10 Z" fill="none" stroke="green" stroke-width="6" />
        <text x="150" y="15" :font-size="textFontSize" text-anchor="start" fill="#666">Normal Difficulty</text>
        <path d="M 290,10 L 310,10 Z" fill="none" stroke="blue" stroke-width="6" />
        <text x="320" y="15" :font-size="textFontSize" text-anchor="start" fill="#666">Easy Difficulty</text>
        <path d="M 460,10 L 480,10 Z" fill="none" stroke="red" stroke-width="6" />
        <text x="490" y="15" :font-size="textFontSize" text-anchor="start" fill="#666">Hard Difficulty</text>

        <path :d="sineWaveEasy" fill="none" stroke="blue" stroke-width="2" />
        <path :d="sineWaveHard" fill="none" stroke="red" stroke-width="2" />
        <path :d="lineRefNormalDif" fill="none" stroke="green" stroke-width="2" />
    </svg>
</template>

<script>
    export default {
        props: {
            width: {
                type: Number,
                default: 400,
            },
            height: {
                type: Number,
                default: 200,
            },
            textFontSize: {
                type: Number,
                default: 14,
            },
            baseScale: {
                type: Number,
                default: 1200,
            },
            limitY: {
                type: Number,
                default: 15,
            },
            pivotY: {
                type: Number,
                default: 2,
            },
            paddingLeft: {
                type: Number,
                default: 20,
            },
            paddingBottom: {
                type: Number,
                default: 20,
            },

            inputPayload: {
                type: Object,
                required: true,
            }
        },
        methods: {
            sineU100(isTakeAll, isTakeBigger, normalLine){
                const {startLineRefU100, freqFirst100Level, startPoint, lengthFreq} = this.inputPayload;
                let connectPoints = "";
                let h = this.getGraphHeight;
                let unitY = this.getHeightUnit;
                let unitX = this.getWidthUnit;
                let isConnect = false;
                for (let i = 1; i <= 100; i++) {
                    let x = i;
                    let y =
                        startLineRefU100 +
                        freqFirst100Level *
                        Math.sin(
                            (x+startPoint) / (1.0 * lengthFreq)
                        );

                    y = Math.max(y, 0.01);

                    if(!isTakeAll){
                        if(isTakeBigger && y < normalLine){
                            isConnect = false;
                            continue;
                        }
                        if(!isTakeBigger && y > normalLine){
                            isConnect = false;
                            continue;
                        }
                    }

                    let p = h - unitY * y;
                    x = x * unitX;
                    if(x >= this.width) break;
                    let nextPoint = `${x+this.getPivotLeft},${p}`;
                    if(isConnect){
                        connectPoints += " L"+nextPoint;
                    } else {
                        connectPoints += " M"+nextPoint;
                    }
                    isConnect = true;
                }

                return connectPoints;
            },

            sineWaveAfter100Level(isTakeAll, isTakeBigger, xStart, xFinish, maxFreqLine){
                const {startLineRef, lengthFreq, lineRefDiff, startPoint, maxFreq, startFreq, diffFreq, levelPerDiffFreq} = this.inputPayload;
                let connectPoints = "";
                let h = this.getGraphHeight;
                let unitY = this.getHeightUnit;
                let unitX = this.getWidthUnit;
                let isConnect = false;
                for (let i = xStart; i <= xFinish; i++) {
                    let x = i;
                    let line = Math.min(maxFreqLine, startLineRef+lineRefDiff*Math.floor(x/levelPerDiffFreq));
                    let freq = Math.min(maxFreq, startFreq+diffFreq*Math.floor(x/levelPerDiffFreq));
                    let amplitude = freq * Math.sin((x+startPoint)/lengthFreq);
                    let y = Math.max(line + amplitude, 0.01);

                    let normalLine = Math.min(maxFreqLine, 2.5+0.8*Math.floor(x/levelPerDiffFreq));
                    if(!isTakeAll){
                        if(isTakeBigger && y < normalLine){
                            isConnect = false;
                            continue;
                        }
                        if(!isTakeBigger && y > normalLine){
                            isConnect = false;
                            continue;
                        }
                    }

                    let p = h - unitY * y;
                    x = x * unitX;
                    if(x >= this.width) break;
                    let nextPoint = `${x+this.getPivotLeft},${p}`;
                    if(isConnect){
                        connectPoints += " L"+nextPoint;
                    } else {
                        connectPoints += " M"+nextPoint;
                    }
                    isConnect = true;
                }

                return connectPoints;
            },

            sineWave1KWithCase(isTakeAll, isTakeBigger){
                const {maxFreqLine1k} = this.inputPayload;
                return this.sineWaveAfter100Level(isTakeAll, isTakeBigger, 101, 1000, maxFreqLine1k);//6.9);
            },

            sineWave10KWithCase(isTakeAll, isTakeBigger){
                const {maxFreqLine10k} = this.inputPayload;
                return this.sineWaveAfter100Level(isTakeAll, isTakeBigger, 1001, 10000, maxFreqLine10k);//8.25);
            },
        },
        computed: {

            getGraphHeight(){
                return this.height - this.paddingBottom;
            },

            getHeightUnit(){
                return this.getGraphHeight/this.limitY;
            },

            getGraphWidth(){
                return this.width - this.getPivotLeft;
            },

            getWidthUnit(){
                return this.getGraphWidth / this.baseScale;
            },

            getPivotTop(){
                //space 18 for header text
                return 18;
            },

            getPivotBottom(){
                return this.getGraphHeight;
            },

            getPivotLeft(){
                return this.paddingLeft;
            },

            getTextCenterPivot(){
                return this.textFontSize/2;
            },

            normalDifficultyLineValue(){
                const {startLineRef} = this.inputPayload;
                return startLineRef;
            },

            normalDifficultyLineY(){
                return this.getPivotBottom - this.getHeightUnit * this.normalDifficultyLineValue;
            },

            AxesData(){
                const points = [];
                points.push(`${this.getPivotLeft},${this.getPivotTop}`);
                points.push(`${this.getPivotLeft},${this.getGraphHeight}`);
                points.push(`${this.width},${this.getGraphHeight}`);
                return `M${points.join(" L")}`;
            },

            AxesXUnit(){
                let axesX = [];
                let unitX = this.getWidthUnit;
                let diff = this.baseScale/12;
                for (let i = 1; i < this.baseScale; i+=diff) {
                    let x = i*unitX+this.getPivotLeft;
                    x = Math.round(x);
                    if(x > this.width) break;
                    let unit = Math.round(i);
                    axesX.push({
                        "key": "ax-"+x,
                        "pointX": x,
                        "unit": "Level:"+unit
                    });
                }
                return axesX;
            },

            AxesYUnit(){
                let axesY = [];
                let h = this.getGraphHeight;
                let unitY = this.getHeightUnit;
                let diff = 2;
                for (let i = 0; i < this.limitY - 2; i+=diff) {
                    let y = h - unitY * i;
                    if(y > this.height) break;
                    axesY.push({
                        "key": "ay-"+y,
                        "pointY": y,
                        "unit": i
                    });
                }
                return axesY;
            },

            lineRefNormalDif(){
                const {levelPerDiffFreq} = this.inputPayload;

                const points = [];
                let h = this.getGraphHeight;
                let unitY = this.getHeightUnit;
                let unitX = this.getWidthUnit;
                let normalLine = 2;
                let p = h - unitY * normalLine;

                //under 100 level
                points.push(`${this.getPivotLeft},${p}`);
                points.push(`${100*unitX+this.getPivotLeft},${p}`);

                //1k
                for (let i = 101; i <= 1000; i++) {
                    let x = i;
                    normalLine = Math.min(6.9, 2.5+0.8*Math.floor(x/levelPerDiffFreq));
                    let p = h - unitY * normalLine;
                    x = x * unitX;
                    if(x >= this.width) break;
                    points.push(`${x+this.getPivotLeft},${p}`);
                }

                //10k
                for (let i = 1001; i <= 10000; i++) {
                    let x = i;
                    normalLine = Math.min(8.25, 2.5+0.8*Math.floor(x/levelPerDiffFreq));
                    let p = h - unitY * normalLine;
                    x = x * unitX;
                    if(x >= this.width) break;
                    points.push(`${x+this.getPivotLeft},${p}`);
                }

                return `M${points.join(" L")}`;
            },

            sineWaveEasy(){
                return this.sineU100(false, true, 2)
                    + this.sineWave1KWithCase(false, true)
                    + this.sineWave10KWithCase(false, true);
            },
            sineWaveHard(){
                return this.sineU100(false, false, 2)
                    + this.sineWave1KWithCase(false, false)
                    + this.sineWave10KWithCase(false, false);
            },
        },
    };
</script>